import React from 'react'
import Filter from 'src/components/search/Filter'
import Button from 'src/components/ui/Button'
import { Funnel as FilterIcon } from 'phosphor-react'
import NavigationCategory from 'src/components/sections/NavigationCategory'
import { useHeaderContext } from 'src/contexts/header-context'
import { useSearch } from '@faststore/sdk'
import type { SearchSort } from '@faststore/sdk/dist/types'
import type {
  CollectionPageQueryQuery,
  Filter_FacetsFragment,
  IStoreSelectedFacet,
} from '@generated/graphql'

import './product-gallery.scss'

interface ProductGalleryProps {
  cmsHome?: CollectionPageQueryQuery['cmsHome']
  idToTop: string
  stickyClass: string
  isFilterOpen: boolean
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>
  filteredFacets: Filter_FacetsFragment[]
  term: string | null
  base: string
  selectedFacets: IStoreSelectedFacet[]
  setSelectedFacets: React.Dispatch<React.SetStateAction<IStoreSelectedFacet[]>>
  sort?: SearchSort
}

export const ProductGalleryNull = ({
  cmsHome,
  idToTop,
  stickyClass,
  isFilterOpen,
  setIsFilterOpen,
  filteredFacets,
  term,
  base,
  selectedFacets,
  setSelectedFacets,
  sort,
}: ProductGalleryProps) => {
  const { isMenuOpen } = useHeaderContext()
  const searchState = useSearch()

  return (
    <>
      <div
        id={`${idToTop ?? idToTop}`}
        className="product-listing__content-grid / grid-content"
      >
        <div
          className={`product-listing__filters${stickyClass} ${
            isMenuOpen ? 'menu-open' : ''
          }`}
        >
          <Filter
            isOpen={isFilterOpen}
            setIsOpen={setIsFilterOpen}
            facets={filteredFacets}
            onDismiss={() => setIsFilterOpen(false)}
            term={term}
            base={base}
            searchState={searchState}
            selectedFacets={selectedFacets}
            setSelectedFacets={setSelectedFacets}
            sort={sort}
          />
        </div>
        <div className="product-listing__wrapper">
          <div className="product-listing__sort">
            <Button
              variant="tertiary"
              data-testid="open-filter-button"
              icon={<FilterIcon size={24} />}
              iconPosition="left"
              aria-label="Abrir filtros"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              FILTRAR
            </Button>
          </div>
        </div>

        <div className="blank-container">
          <h1> Infelizmente não encontramos resultados para a sua busca</h1>
          <div className="intruction-container">
            <h3>Ao realizar nova busca, você pode: </h3>
            <ul className="blank-list">
              <li>verificar a ortografia da palavra</li>
              <li>usar apenas uma palavra</li>
              <li>buscar por termos genéricos</li>
              <li>tentar o uso de sinônimos</li>
            </ul>
          </div>
          {cmsHome ? (
            <section className="page__section">
              <NavigationCategory
                title="OU SE PREFERIR, VOCÊ PODE NAVEGAR PELAS NOSSAS CATEGORIAS"
                variant="search"
                subtitle={null}
                {...cmsHome?.sections?.[1]?.data}
              />
            </section>
          ) : null}
        </div>
      </div>
    </>
  )
}
